import { useEffect, useState, useCallback } from "react";
import { AdditionalDocumentDTO } from "../types/AdditionalDocumentDTO";
import { AdditionalDocumentCategoryDTO } from "../types/AdditionalDocumentCategoryDTO";
import {
  getAdditionalDocuments,
  getAdditionalDocumentCategories,
} from "../api/additionalDocuments";

export function useAdditionalDocuments(companyId: string) {
  const [documents, setDocuments] = useState<AdditionalDocumentDTO[]>([]);
  const [categories, setCategories] = useState<AdditionalDocumentCategoryDTO[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const [docs, cats] = await Promise.all([
        getAdditionalDocuments(companyId),
        getAdditionalDocumentCategories(companyId),
      ]);

      setDocuments(docs);
      setCategories(cats);
    } catch (err: any) {
      setError(err?.message ?? "Błąd ładowania danych");
    } finally {
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    documents,
    setDocuments,
    categories,
    loading,
    error,
    reload: load,
  };
}
